module.exports = __webpack_public_path__ + "static/media/English.fb239652.jpg";